import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <p className="footer-brand">
            <span className="footer-accent">U.S.</span> Auto Glass
          </p>
          <p className="footer-text">
            Family-owned auto glass experts serving DC, Maryland & Virginia.
          </p>
        </div>
        <p className="footer-copy">
          © {new Date().getFullYear()} U.S. Auto Glass LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
